// BoardView.js — renders the grid, bars and the player cursor from GameState.
// Builds the static grid once; render(state) updates what changed. The player's
// position is shown by a square highlight that glides to the current cell.

import { GRID } from "../config.js";

export class BoardView {
    constructor(rootEl) {
        this._root = rootEl;
        this._cells = [];
        this._buildGrid();

        this._cursor = document.createElement("div");
        this._cursor.className = "player-cursor";
        this._board.appendChild(this._cursor);
    }

    _buildGrid() {
        // Set on <html> so :root's --board-w (which sizes board + HUD to fit
        // the viewport) can read the grid dimensions.
        document.documentElement.style.setProperty("--cols", GRID.cols);
        document.documentElement.style.setProperty("--rows", GRID.rows);

        this._board = document.createElement("div");
        this._board.className = "board";

        for (let i = 0; i < GRID.cols * GRID.rows; i++) {
            const cell = document.createElement("div");
            cell.className = "tile";
            this._board.appendChild(cell);
            this._cells.push(cell);
        }
        this._root.appendChild(this._board);
    }

    render(state) {
        for (const cell of this._cells) {
            cell.textContent = "";
            cell.className = "tile";
        }

        const nextOrder = state.pathIndex + 1;

        for (const item of state.items) {
            const cell = this._cells[item.row * GRID.cols + item.col];
            if (!cell) continue;
            cell.textContent = item.char;
            cell.classList.add("tile--bar");
            if (item.collected) cell.classList.add("tile--collected");
            else if (item.missed) cell.classList.add("tile--missed");
            else if (item.order === nextOrder) cell.classList.add("tile--next");
            // The kanji whose character is being sung right now pulses, so the
            // board stays in sync with the music.
            if (item.order === state.activeCharIndex) cell.classList.add("tile--singing");
        }

        // Move the player highlight to the current cell. Positioning is done in
        // CSS from --col/--row (gap-aware), so it lines up and tweens smoothly.
        this._cursor.style.setProperty("--col", state.miku.col);
        this._cursor.style.setProperty("--row", state.miku.row);
    }
}
